import React, { useEffect, useState } from "react";

import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import "./SelectSchoolModal.scss";

import { getSchoolTypesRequest } from "../../../../../../Backend/SchoolsRequests";
import { FormInput } from "../../../../../../Components";
import { FormSelect } from "../../../../../../Components/Buttons/FormSelect/FormSelect";
import { Roles } from "../../../../../../Constants";
import { hasValue } from "../../../../../../Helpers/validations/common";

export function SelectSchoolModal({ schoolList, schoolSelected, setSchoolSelected, ...props }) {
    const [t] = useTranslation();
    const userData = useSelector((state) => state.user.credentials);
    const [schoolListFiltered, setSchoolListFiltered] = useState([]);
    const [filters, setFilters] = useState({
        schoolNumber: "",
        schoolName: "",
    });

    const [schoolTypeList, setSetSchoolTypeList] = useState([]);
    const [schoolTypeSelected, setSchoolTypeSelected] = useState("All");

    useEffect(() => {
        getSchoolTypes();
    }, []);

    useEffect(() => {
        filterSchools();
    }, [filters, schoolTypeSelected]);

    const getSchoolTypes = async () => {
        const resp = await getSchoolTypesRequest();
        if (resp.success) {
            if (resp.data.length > 0) {
                const types = resp.data.map((type) => {
                    return { id: type, name: t(type) };
                });
                setSetSchoolTypeList([{ id: "All", name: t("All") }, ...types]);
            }
        }
    };

    const filterSchools = () => {
        const filteredSchools = schoolList.filter((school) => {
            const matchesSchoolNumber = hasValue(filters.schoolNumber)
                ? school.schoolNumber.toString() === filters.schoolNumber
                : true;
            const matchesSchoolName = school.name.toLowerCase().includes(filters.schoolName.toLowerCase());
            const matchesType =
                schoolTypeSelected === "All"
                    ? true
                    : schoolTypeSelected.toLowerCase() === school.schoolDeliveryType.toLowerCase();

            return matchesSchoolNumber && matchesSchoolName && matchesType;
        });
        setSchoolListFiltered(filteredSchools);
    };

    const renderSchoolItem = (school) => {
        const selected = school.id === schoolSelected.id;
        return (
            <div
                className={`school-wrapper ${selected ? `selected` : ``}`}
                key={"school-" + school.schoolNumber}
                onClick={() => {
                    setSchoolSelected(school);
                    props.onHide();
                }}
            >
                <div className="select-school">
                    <div className="school-number">{school.schoolNumber}</div>
                    <div className="school-name">{school.name}</div>
                </div>
            </div>
        );
    };

    return (
        <Modal {...props} centered dialogClassName="select-school-modal">
            <Modal.Header closeButton>
                <span className="title">{t("SelectSchool")}</span>
            </Modal.Header>
            <Modal.Body className="select-school-content">
                <div className="subtitle">{t("SelectSchoolText")}</div>
                <div className="filters-wrapper">
                    <div className="input-wrapper">
                        <span className="label">{t("SchoolNumber")}</span>
                        <FormInput
                            placeholder=""
                            type="number"
                            value={filters.schoolNumber}
                            change={(x) => setFilters({ ...filters, schoolNumber: x })}
                        />
                    </div>
                    <div className="input-wrapper">
                        <span className="label">{t("SchoolName")}</span>
                        <FormInput
                            placeholder=""
                            type="text"
                            value={filters.schoolName}
                            change={(x) => setFilters({ ...filters, schoolName: x })}
                        />
                    </div>
                </div>

                {userData.role !== Roles.SchoolManager && (
                    <div className="filters-wrapper">
                        <div className="input-wrapper">
                            <span className="label">{t("SchoolType")}</span>
                            <FormSelect
                                type="text"
                                options={schoolTypeList}
                                value={schoolTypeSelected}
                                change={(x) => setSchoolTypeSelected(x)}
                            />
                        </div>
                    </div>
                )}

                <div className="subtitle">
                    {`${schoolListFiltered.length} 
          ${t("PaginatorOf")} 
          ${schoolList.length}
          ${t("Schools")}`}
                </div>
                <div className="school-list">
                    {schoolListFiltered.map((school) => {
                        return renderSchoolItem(school);
                    })}
                </div>
            </Modal.Body>
        </Modal>
    );
}
